import { useReleaseFlag } from 'hooks/useReleaseFlags';
import { Link } from 'shared/types';
import { FormLinksBase } from './FormLinksBase';

export type LinksFormValues = {
  expandLinks: boolean;
  links: Link[];
};

export const FormLinks = (): JSX.Element => {
  const isInternalTabEnabled = useReleaseFlag('internal_tab_on_incidents');

  return (
    <FormLinksBase
      labelKey={
        isInternalTabEnabled
          ? 'geoEvent.structuredInfo.links'
          : 'createEditLocation.sections.links'
      }
      linksField="links"
      expandField="expandLinks"
    />
  );
};
